<template>
  <OmtStickedModal v-if="isOpen" data-cy="refund-create-terms-modal"
@close="close">
    <OmtRow mb="24px">
      <OmtTypography as="h1-bold"> Evite atrasos na liberação do seu reembolso </OmtTypography>
    </OmtRow>

    <OmtRow>
      <CBox mb="24px">
        <OmtTypography as="p1" mb="8px">
          Confira os documentos e informações necessárias para cada tipo de reembolso.
        </OmtTypography>
      </CBox>
    </OmtRow>

    <OmtRow>
      <CBox mb="24px">
        <CAccordion :defaultIndex="-1" :allowToggle="true">
          <CAccordionItem>
            <PanelTitle title="Consultas" icon="stethoscope" />
            <ConsultasPanel />
          </CAccordionItem>
          <OmtDivider />
          <CAccordionItem>
            <PanelTitle title="Exames" icon="flask" />
            <ExamesPanel />
          </CAccordionItem>
          <OmtDivider />
          <CAccordionItem>
            <PanelTitle title="Vacinas" icon="syringe" />
            <VacinasPanel />
          </CAccordionItem>
          <OmtDivider />
          <CAccordionItem>
            <PanelTitle title="Acupuntura*, Escleroterapia* e Nutrição" icon="stethoscope" />
            <AcupunturaPanel />
          </CAccordionItem>
          <OmtDivider />
          <CAccordionItem>
            <PanelTitle
              title="Fisioterapia, Fonoaudiologia, RPG, Terapia Ocupacional e Psicoterapia"
              icon="clipboard-list-check"
            />
            <FisioterapiaPanel />
          </CAccordionItem>
          <OmtDivider />
          <CAccordionItem>
            <PanelTitle title="Internações e Cirurgias" icon="hospital" />
            <InternacoesPanel />
          </CAccordionItem>
          <OmtDivider />
          <CAccordionItem>
            <PanelTitle title="Odontologia" icon="tooth" />
            <OdontologiaPanel />
          </CAccordionItem>
        </CAccordion>
      </CBox>
    </OmtRow>

    <OmtRow align-items="flex-end" pb="18px"
pt="24px" bg="white" :desktopStart="4" :desktopEnd="9">
      <OmtButton @click="onContinue"> Continuar </OmtButton>
    </OmtRow>
  </OmtStickedModal>
</template>

<script>
import EmphasysRow from "@/components/Atoms/emphasys-row.vue";
import IconRow from "@/components/Atoms/icon-row.vue";
import RefundAttentionAdviser from "@/components/Organisms/RefundNew/RefundAttentionAdviser.vue";
import RefundInvoiceAdviser from "@/components/Organisms/RefundNew/RefundInvoiceAdviser.vue";
import { defineComponent } from "vue";

import AcupunturaPanel from "@/components/Organisms/RefundNew/topics/AcupunturaPanel.vue";
import ConsultasPanel from "@/components/Organisms/RefundNew/topics/ConsultasPanel.vue";
import ExamesPanel from "@/components/Organisms/RefundNew/topics/ExamesPanel.vue";
import FisioterapiaPanel from "@/components/Organisms/RefundNew/topics/FisioterapiaPanel.vue";
import InternacoesPanel from "@/components/Organisms/RefundNew/topics/InternacoesPanel.vue";
import OdontologiaPanel from "@/components/Organisms/RefundNew/topics/OdontologiaPanel.vue";
import PanelTitle from "@/components/Organisms/RefundNew/topics/PanelTitle.vue";
import VacinasPanel from "@/components/Organisms/RefundNew/topics/VacinasPanel.vue";
import { mapState } from "vuex";

export default defineComponent({
  components: {
    EmphasysRow,
    IconRow,
    RefundInvoiceAdviser,
    RefundAttentionAdviser,
    PanelTitle,
    ConsultasPanel,
    ExamesPanel,
    VacinasPanel,
    AcupunturaPanel,
    FisioterapiaPanel,
    InternacoesPanel,
    OdontologiaPanel
  },
  props: {
    isOpen: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("refund", ["newRefund"])
  },
  mounted() {
    if (!this.newRefund || this.newRefund.type === null) {
      this.$router.push({ name: "refund.new.create" });
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    onContinue() {
      this.$router.push({
        name: "refund.new.create.credit-inform"
      });
    }
  }
});
</script>
